module.exports = __webpack_public_path__ + "assets/img/detail16.b751dc31.png";